import React from "react";
import { Icon } from "@cadmakers-ui/icons";
import iconStyles from "../../../Common/Styles/Icons.module.scss";
import { Topic } from "../../Models/Topic";
import { ProtectedContent } from "../../../Auth";
import { Role } from "../../../Common/Constants/roleEnums";
import { ErrorHandling } from "../../../Auth/Components/ProtectedContent";
import ElementSpacer from "../../../Layout/Components/ElementSpacer";
import { IconButton } from "../../../Layout";
import { TopicType } from "../../Enums/TopicType";
import { ArchiveTopicModal } from "../ArchiveTopicModal";
import { EditTopicModal } from "../EditTopicModal";
import AssignTopicUsersModal from "../AssignTopicUsersModal";
import AssignTopicManagersModal from "../AssignTopicManagersModal";

type Props = {
  topic: Topic;
  onArchive: (topic: Topic) => void;
  onEdit: (topic: Topic, callback: () => void) => void;
  onEditWorkflow: (topic: Topic) => void;
};

type State = {
  archiveModalToggle: boolean;
  editModalToggle: boolean;
  assignUserModalToggle: boolean;
  assignManagersToggle: boolean;
};

export class TopicListItemButtons extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      archiveModalToggle: false,
      editModalToggle: false,
      assignUserModalToggle: false,
      assignManagersToggle: false
    };
  }

  onArchiveModalToggle = () => {
    this.setState(prevState => ({
      archiveModalToggle: !prevState.archiveModalToggle
    }));
  };

  onEditModalToggle = () => {
    this.setState(prevState => ({
      editModalToggle: !prevState.editModalToggle
    }));
  };

  onAssignUserModalToggle = () => {
    this.setState(prevState => ({
      assignUserModalToggle: !prevState.assignUserModalToggle
    }));
  };

  onAssignManagersModalToggle = () => {
    this.setState(prevState => ({
      assignManagersToggle: !prevState.assignManagersToggle
    }));
  };

  onClickEditWorkflow = () => {
    this.props.onEditWorkflow(this.props.topic);
  };

  render() {
    const canEdit =
      this.props.topic.isLoggedInUserManager || this.props.topic.canLoggedInUserEditIfNotManager;

    return (
      <div onClick={e => e.stopPropagation()}>
        <ProtectedContent
          roles={[Role.Admin, Role.CMAdmin]}
          errorHandling={ErrorHandling.ShowNothing}
        >
          <ElementSpacer spacing="5px">
            {canEdit && (
              <span>
                <IconButton
                  icon={
                    <Icon
                      appName="GeneralLayout"
                      assetName="GENERAL_L_CreateEdit"
                      className={iconStyles.smallIcon}
                    />
                  }
                  color="black"
                  hoverColor="#188cd9"
                  title="Edit"
                  onClick={this.onEditModalToggle}
                />
                <EditTopicModal
                  topic={this.props.topic}
                  toggle={this.state.editModalToggle}
                  onToggle={this.onEditModalToggle}
                  onEdit={this.props.onEdit}
                />
              </span>
            )}
            <span>
              <IconButton
                color="black"
                hoverColor="orange"
                icon={
                  <Icon
                    appName="GeneralLayout"
                    assetName="GENERAL_L_Archive"
                    className={iconStyles.smallIcon}
                  />
                }
                onClick={this.onArchiveModalToggle}
                title="Archive"
              />
              <ArchiveTopicModal
                topic={this.props.topic}
                toggle={this.state.archiveModalToggle}
                onToggle={this.onArchiveModalToggle}
                onArchive={this.props.onArchive}
              />
            </span>

            {this.props.topic.type === TopicType.Private && canEdit && (
              <span>
                <IconButton
                  icon={
                    <Icon
                      appName="GeneralLayout"
                      assetName="GENERAL_F_UserF"
                      className={iconStyles.smallIcon}
                    />
                  }
                  onClick={this.onAssignUserModalToggle}
                  title="Assign Users"
                  hoverColor="#188cd9"
                  color="black"
                />
                <AssignTopicUsersModal
                  topic={this.props.topic}
                  toggle={this.state.assignUserModalToggle}
                  onToggle={this.onAssignUserModalToggle}
                />
              </span>
            )}
            {canEdit && (
              <span>
                <IconButton
                  icon={
                    <span className="fa-layers fa-fw">
                      <Icon
                        appName="GeneralLayout"
                        assetName="GENERAL_Supervision"
                        className={iconStyles.smallIcon}
                      />
                    </span>
                  }
                  onClick={this.onAssignManagersModalToggle}
                  title="Assign Managers"
                  hoverColor="#188cd9"
                  color="black"
                />
                <AssignTopicManagersModal
                  topic={this.props.topic}
                  toggle={this.state.assignManagersToggle}
                  onToggle={this.onAssignManagersModalToggle}
                />
              </span>
            )}
          </ElementSpacer>
        </ProtectedContent>
        {canEdit && (
          <span style={{ marginLeft: "5px" }}>
            <IconButton
              icon={
                <Icon
                  appName="GeneralLayout"
                  assetName="GENERAL_L_ProjectWorkflow"
                  className={iconStyles.smallIcon}
                />
              }
              onClick={this.onClickEditWorkflow}
              title="Edit Workflow"
              hoverColor="#188cd9"
              color="black"
            />
          </span>
        )}
      </div>
    );
  }
}
